import { Check } from 'lucide-react';

import { Skeleton } from '@/slw/shared/ui/skeleton';

export function ShowcaseSection({ features, isLoading }: { features: string[]; isLoading: boolean }) {
  if (isLoading) {
    return (
      <div className='space-y-12'>
        <h2 className='text-2xl font-bold leading-[150%]'>Showcase Your Classic With Us!</h2>
        <div className='space-y-2.5 px-6'>
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className='flex items-start space-x-2.5'>
              <Skeleton className='w-5 h-5 rounded-full' />
              <Skeleton className='h-4 w-3/4' />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className='space-y-12'>
      <h2 className='text-2xl font-bold leading-[150%]'>Showcase Your Classic With Us!</h2>

      <div className='space-y-2.5 px-6'>
        {features.map((feature, index) => (
          <div key={index} className='flex items-start space-x-2.5'>
            <div className='flex-shrink-0'>
              <div className='w-5 h-5 bg-green-500 rounded-full flex items-center justify-center'>
                <Check className='w-3 h-3 text-white' strokeWidth={2} />
              </div>
            </div>
            <p className='text-sm font-medium leading-[150%]'>{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
